/**
 * Version information for Trip Planner Frontend
 */

// Version information
export const VERSION = "1.2.0";
export const BUILD_DATE = new Date().toISOString();
export const GIT_COMMIT = import.meta.env.VITE_GIT_COMMIT || "unknown";
export const ENVIRONMENT = import.meta.env.MODE || "development";

export interface VersionInfo {
  version: string;
  buildDate: string;
  gitCommit: string;
  environment: string;
}

export function getVersionInfo(): VersionInfo {
  return {
    version: VERSION,
    buildDate: BUILD_DATE,
    gitCommit: GIT_COMMIT,
    environment: ENVIRONMENT
  };
}

export function printVersionInfo(): void {
  const versionInfo = getVersionInfo();
  console.log("=".repeat(60));
  console.log("🚀 TRIP PLANNER FRONTEND");
  console.log("=".repeat(60));
  console.log(`📦 Version: ${versionInfo.version}`);
  console.log(`📅 Build Date: ${versionInfo.buildDate}`);
  console.log(`🔗 Git Commit: ${versionInfo.gitCommit}`);
  console.log(`🌍 Environment: ${versionInfo.environment}`);
  console.log("=".repeat(60));
}
